export default __webpack_public_path__ + "static/media/student_girl.dc530f56.jpg";